/* Banner Home Alt Component JS File */ 
$(document).ready(function() {

});
